<app-loader-component
   [isLoaded]="!loading"
   loaderType="APP_LOADER"></app-loader-component>
